<template>
    <form id="ReviewsForm" method="post" action="/ajax_new/Forms/review/"
          enctype="multipart/form-data" @submit.prevent="submit">
        <div class="form-group">
            <label for="ReviewsForm_reviewName">
                Имя
            </label>
            <div class="form-group">
                <input type="text" name="REVIEW_NAME" placeholder="Имя"
                       class="form-control" v-model="name" id="ReviewsForm_reviewName" :readonly="userAuthorized && name"/>
            </div>
        </div>
        <div class="form-group" :class="{ 'form-group--error': $v.text.$error }">
            <label for="ReviewsForm_reviewText">
                Текст отзыва
                <span class="color-red">*</span>
            </label>
            <textarea class="form-control" name="REVIEW_TEXT" rows="5" id="ReviewsForm_reviewText"
                      v-model.trim="$v.text.$model" @blur="$v.text.$touch()">
            </textarea>
            <div class="invalid-input" v-if="!$v.text.required">
                Поле обязательно для заполнения
            </div>
        </div>
        <div class="form-group"  v-if="!userAuthorized">
            Нажимая на кнопку «Отправить» вы подтверждаете,
            что согласны с
            <a href="/policy-personal-data" class="policy-data" target="_blank">
                Политикой обработки персональных данных
            </a>
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-primary">Отправить</button>
        </div>
        <div class="alert alert-dismissable fade show alert-danger" role="alert" v-if="errors.length">
            {{ errors[0].message }}
        </div>
    </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'

  export default {
    name: 'review',
    mixins: [validationMixin],
    data: function () {
      return {
        name: '',
        text: '',
        userAuthorized: false,
        message: '',
        errors: []
      }
    },
    validations: {
      text: {
        required
      }
    },
    created: function () {
      this.userAuthorized = this.$attrs.application.userAuthorized
      this.name = this.$attrs.application.userFullName

      if (this.userAuthorized) {
        this.check = true
      }
    },
    methods: {
      submit: async function (e) {
        this.errors = []
        this.message = ''
        this.$v.$touch()

        let targetNode = e.target
        let action = targetNode.action

        if (!this.$v.$invalid) {
          let formData = new FormData(targetNode)

          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('review')

          formData.append('g-recaptcha-response', token)
          formData.append('IB', this.$attrs.application.IB)

          this.$http.post(action, formData).then(request => {
            if (request.data.status) {
              window.$('#ModalFormResponce').modal('show')

              window.$('#ModalFormResponce').on('hidden.bs.modal', function (e) {
                window.location.href = request.data.data.localRedirect
              })
            } else {
              this.errors = request.data.errors
            }
          }).catch(error => {
            console.error(error)
          })
        }
      }
    }
  }
</script>

<style lang="scss">
    .invalid-input {
        display: none;
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #dc3545;
    }

    .form-group--error {
        .form-control {
            border-color: #dc3545;
        }

        .invalid-input {
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/vue/components/forms/Review.vue